import { FunctionComponent, memo } from 'react';
import { useTranslation } from 'react-i18next';

import classes from './MentionContent.module.scss';

interface MentionContentProps {
  authorName: string;
  title: string;
}

export const MentionContent: FunctionComponent<MentionContentProps> = memo(
  ({ authorName, title }) => {
    const { t } = useTranslation();

    return (
      <div className={classes['content']}>
        <strong>{authorName}</strong>&nbsp;
        {t('channelNotifications.mentioned-in-post')}&nbsp;"{title}"
      </div>
    );
  }
);
